import React, { useState, useEffect } from "react";
import { Row, Button } from "reactstrap";
import DatePicker from "react-datepicker";
import DayTime from "../../../../../common/DayTimeWrapper";
import { cloneDeep } from "lodash";
import { useLocation, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAllImprovementListing,
  fetchViewDetailReport,
  intiateCorrectionAndApproveForImprovement,
} from "../../../Action";
import PopupMsgWrapper from "../../../../../common/PopupMsgWrapper";
import { userDetails } from "../../../../../../helper";
import Toaster from "../../../../../common/Toaster";
import LoaderCustom from "../../../../../common/LoaderCustom";
const ImprovementPlan = ({ viewDataFromSupplier, viewDataFromReport }) => {

  const [loadingImprovement, setImprovementLoading] = useState(false);
  const EmpId = userDetails()
  const location = useLocation();
  let history = useHistory();

  const searchParams = new URLSearchParams(location.search);
  const vendorId = searchParams.get("VendorRequirementRegistrationId");
  const NSAAuditDetailId = searchParams.get("nsaAuditDetailId");
  const [remark, setRemark] = useState("");

  const dispatch = useDispatch();
  const [remarkAccept, setRemarkAccept] = useState(false);
  const [remarkApprove, setRemarkApprove] = useState(false);
  const { improvementPlanList } = useSelector(
    (state) => state?.improvementPlanReducer
  );

  const getUsers = async (vendorId) => {
    try {
      // Set loading state to true to indicate data fetching
      setImprovementLoading(true);
      // Dispatch the action to fetch users

      await dispatch(
        fetchAllImprovementListing({
          vendorId,
          NSAAuditDetailId,
          // SearchText: SearchText ? SearchText : "",
        })
      );
      // Reset loading state to false after the data is fetched
      setImprovementLoading(false);
    } catch (error) {
      // Handle errors, e.g., display an error message


      // Reset loading state to false in case of an error
      setImprovementLoading(false);
    }
  };
  const closePopUp = () => {
    setRemarkAccept(false);
    setRemarkApprove(false);
  };
  const getUsersAudit = async (vendorRegId, nsaAuditDetailId) => {
    try {
      await dispatch(
        fetchViewDetailReport({
          vendorID: vendorRegId,
          nsaAuditDetailId: nsaAuditDetailId,
        })
      );
    } catch (error) {

    }
  };
  useEffect(() => {
    getUsersAudit(parseInt(vendorId), parseInt(NSAAuditDetailId));
    if (viewDataFromSupplier?.ApprovedDate !== null) {
      getUsers(vendorId);
    }
  }, []);

  const [targetStartDateNC, setTargetStartDate] = useState({});
  const [targeEndDateNC, setTargetEndDate] = useState({});
  const [actionPan, setActionPan] = useState({});
  const [responsibilityPlan, setResponsibilityPlan] = useState({});
  useEffect(() => {
    const initialTargetStartDate = {};
    const initialTargetEndDate = {};
    const initialActionPlan = {};
    const initialResponsibility = {};

    // Set initial target start and end dates f2rom data
    improvementPlanList &&
      improvementPlanList?.improvmentPlanModelList?.forEach((item) => {
        initialTargetStartDate[item.ncDetailId] = item?.targetStartDate;
        initialTargetEndDate[item.ncDetailId] = item?.targetEndDate;
        initialActionPlan[item.ncDetailId] = item?.actionPlan;
        initialResponsibility[item.ncDetailId] = item?.responsibility;
      });

    // Set initial state with the obtained values
    setTargetStartDate(initialTargetStartDate);
    setTargetEndDate(initialTargetEndDate);
    setActionPan(initialActionPlan);
    setResponsibilityPlan(initialResponsibility);
  }, [improvementPlanList]); // Make sure to add dependencies if needed
  // Dependency on improvementPlanList, so whenever it changes, the effect runs again

  // Event handler for changing action plan

  const handleStartDateChangeNC = (date, selectedNcDetailId) => {
    let updatedDate = cloneDeep(targetStartDateNC);
    updatedDate[selectedNcDetailId] = date
      ? DayTime(date, "YYYY-MM-DDTHH:mm:ss.SSSZ").format("MM/DD/YYYY")
      : null;
    setTargetStartDate(updatedDate);
  };

  const handleEndDateChangeNC = (date, selectedNcDetailId) => {
    let updatedDate = cloneDeep(targeEndDateNC);
    updatedDate[selectedNcDetailId] = date
      ? DayTime(date, "YYYY-MM-DDTHH:mm:ss.SSSZ").format("MM/DD/YYYY")
      : null;
    setTargetEndDate(updatedDate);
  };
  const handleActionPlanChange = (e, ncDetailId) => {
    const newActionPlan = e.target.value;
    setActionPan((prevState) => ({
      ...prevState,
      [ncDetailId]: newActionPlan,
    }));
  };

  const handleResponsibilityChange = (e, ncDetailId) => {
    const newResponsibility = e.target.value;
    setResponsibilityPlan((prevState) => ({
      ...prevState,
      [ncDetailId]: newResponsibility,
    }));
  };

  const processedData =
    improvementPlanList &&
    improvementPlanList?.improvmentPlanModelList?.reduce((acc, item) => {
      const existingEntryIndex = acc.findIndex(
        (entry) => entry.improvementPointId === item.improvementPointId
      );
      if (existingEntryIndex === -1) {
        acc.push({
          improvementPointId: item.improvementPointId,
          improvementPoint: item.improvementPoint,
          nonConfirmity: [
            {
              ncDetailId: item.ncDetailId,
              nonConfirmity: item.nonConfirmity,
              actionPlan: item.actionPlan,
              responsibility: item.responsibility,
              targetStartDate: item.targetStartDate, // Include target start date
              targetEndDate: item.targetEndDate, // Include target end date
            },
          ],
        });
      } else {
        const existingEntry = acc[existingEntryIndex];
        const existingNcIndex = existingEntry.nonConfirmity.findIndex(
          (nc) => nc.nonConfirmity === item.nonConfirmity
        );
        if (existingNcIndex === -1) {
          existingEntry.nonConfirmity.push({
            ncDetailId: item.ncDetailId,
            nonConfirmity: item.nonConfirmity,
            actionPlan: item.actionPlan,
            responsibility: item.responsibility,
            targetStartDate: item.targetStartDate, // Include target start date
            targetEndDate: item.targetEndDate, // Include target end date
          });
        }
      }
      return acc;
    }, []);

  let serialNo = 1;
  // const handleSubmit = () => {
  //   const improvementPlanLists = Object.keys(actionPan).map((ncDetailId) => ({
  //     actionPlan: actionPan[ncDetailId],
  //     responsibility: responsibilityPlan[ncDetailId],
  //     vendorRequirementRegistrationId: null, // You may need to adjust this value
  //     targetStartDate: targetStartDateNC[ncDetailId],
  //     targetEndDate: targeEndDateNC[ncDetailId],
  //     ncDetailId: parseInt(ncDetailId), // Convert to integer if needed
  //     nsaAuditAssessmentDetailID: null, // You may need to adjust this value
  //     employeeId: 1, // Example value, replace with actual employee ID
  //   }));

  //   const payload = { improvementPlanLists };
  //    // Or send this payload to your API endpoint
  // };
  const popupInputData = (data) => {
    // 
    setRemark(data);
  };
  const handleRequestForConfirmation = async (data) => {


    try {
      if (!remark) {
        // setFormErrorForCorrection("Please enter a remark");
        return;
      }
      const userDetail = userDetails();
      const reviewRequesterData = {
        ApprovedOrReject: parseInt(data),
        remark: remark,
        ActionTakenByUserId: parseInt(userDetail?.EmployeeId),
        vendorRequirementRegistrationId: parseInt(vendorId),
      };
      setImprovementLoading(true);

      const res = await new Promise((resolve, reject) => {
        dispatch(
          intiateCorrectionAndApproveForImprovement(
            reviewRequesterData,
            (response) => {
              if (response) {
                resolve(response);
              } else {
                reject("An error occurred while processing the request");
              }
            }
          )
        );
      });

      if (res && res?.data?.IsSuccessful) {
        Toaster.success(res?.data?.FriendlyMessage);
        history.push("/nsa-list");
      }

      setRemark("");
      setRemarkAccept(false);
      setRemarkApprove(false);
    } catch (error) {

      // Handle the error, e.g., display an error message to the user
    } finally {
      setImprovementLoading(false);
    }
  };

  if (loadingImprovement) {
    return (
      <div>
        <LoaderCustom customClass="simulation-Loader" />
      </div>
    );
  }

  return (
    <div className="">
      <Row className="filter-row-large"></Row>
      <div className="hl-nsa-review-details mb-4">
        <table
          responsive
          hover
          bordered
          className="improvement-plan-table w-100"
        >
          <thead>
            <tr>
              <th style={{ width: '80px' }}>S. No.</th>
              <th style={{ width: '180px' }}>Audit Point</th>
              <th style={{ width: '200px' }}>Non Conformity</th>
              <th style={{ width: '250px' }}>Action Plan</th>
              <th style={{ width: '150px' }}>Responsibility</th>
              <th style={{ width: '120px' }}>Target Start Date</th>
              <th style={{ width: '120px' }}>Target End Date</th>
            </tr>
          </thead>
          <tbody>
            {processedData?.map((item, index) => (
              <React.Fragment key={item.improvementPointId}>
                {item.nonConfirmity.map((nc, i) => (
                  <tr key={`${item.improvementPointId}-${i}`}>
                    {i === 0 && (
                      <td rowSpan={item.nonConfirmity.length}>{serialNo++}</td>
                    )}
                    {i === 0 && (
                      <td rowSpan={item.nonConfirmity.length}>
                        {item.improvementPoint}
                      </td>
                    )}
                    <td>{nc.nonConfirmity}</td>
                    <td>
                      <textarea
                        className="action-plan-textarea form-control"
                        disabled
                        value={actionPan[nc.ncDetailId] || ""}
                        onChange={(e) =>
                          handleActionPlanChange(e, nc.ncDetailId)
                        }
                        style={{ minHeight: '80px', width: '100%' }}
                      />
                    </td>
                    <td>
                      <input
                        className="responsibility-plan-textarea form-control"
                        disabled
                        value={responsibilityPlan[nc.ncDetailId] || ""}
                        onChange={(e) =>
                          handleResponsibilityChange(e, nc.ncDetailId)
                        }
                        style={{ width: '100%' }}
                      />
                    </td>
                    <td>
                      <div className="inputbox date-section">
                        <DatePicker
                          selected={
                            targetStartDateNC[nc.ncDetailId]
                              ? DayTime(
                                targetStartDateNC[nc.ncDetailId]
                              ).toDate()
                              : null
                          }
                          onChange={(date) =>
                            handleStartDateChangeNC(date, nc.ncDetailId)
                          }
                          name="targetStartDate"
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          dateFormat="dd/MM/yyyy"
                          placeholderText="Select"
                          className="withBorder mb-0 w-100"
                          autoComplete="off"
                          disabledKeyboardNavigation
                          disabled
                          onChangeRaw={(e) => e.preventDefault()}
                        />
                      </div>
                    </td>
                    <td>
                      <div className="inputbox date-section">
                        <DatePicker
                          selected={
                            targeEndDateNC[nc.ncDetailId]
                              ? DayTime(targeEndDateNC[nc.ncDetailId]).toDate()
                              : null
                          }
                          onChange={(date) =>
                            handleEndDateChangeNC(date, nc.ncDetailId)
                          }
                          name="targetEndDate"
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          dateFormat="dd/MM/yyyy"
                          placeholderText="Select"
                          className="withBorder mb-0 w-100"
                          autoComplete="off"
                          disabledKeyboardNavigation
                          disabled
                          onChangeRaw={(e) => e.preventDefault()}
                        />
                      </div>
                    </td>
                  </tr>
                ))}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
      <Row className="justify-content-between sf-btn-footer no-gutters justify-content-between bottom-footer sticky-btn-footer hl-btm-footer">
        <div className="col-sm-12 text-right bluefooter-butn">
          {/* Assuming buttons are handled elsewhere, removed them for clarity */}

          {improvementPlanList?.improvnmentPlanstatus == 23 &&
            !viewDataFromReport?.data?.isKYS2ApprovedByApprover &&
            (EmpId?.EmployeeId == viewDataFromSupplier?.VNFLastLevelApproverId || viewDataFromReport?.kys2LevelId?.some(
              (id) => id == EmpId?.EmployeeId
            )) && (
              <button
                type="button"
                className="mr-2 approve-button mr5 approve-hover-btn"
                onClick={() => {
                  setRemarkApprove(true);
                }}
              >
                <div className="save-icon"></div> {"Approve"}
              </button>
            )}
          {improvementPlanList?.improvnmentPlanstatus == 23 &&
            !viewDataFromReport?.data?.isKYS2ApprovedByApprover &&
            (EmpId?.EmployeeId == viewDataFromSupplier?.VNFLastLevelApproverId || viewDataFromReport?.kys2LevelId?.some(
              (id) => id == EmpId?.EmployeeId
            )) && (
              <Button
                type="primary"
                className="btn-primary ml-2"
                onClick={() => {
                  setRemarkAccept(true);
                }}
              >
                <div className="send-for-approval mr-1"></div> Request for
                Correction
              </Button>
            )}
        </div>
      </Row>
      {remarkAccept && (
        <PopupMsgWrapper
          setInputData={popupInputData}
          isOpen={remarkAccept}
          header={"Remark"}
          closePopUp={closePopUp}
          confirmPopup={() => handleRequestForConfirmation(2)}
          isInputField={true} // Assuming you want an input field in your popup
        />
      )}
      {remarkApprove && (
        <PopupMsgWrapper
          setInputData={popupInputData}
          isOpen={remarkApprove}
          header={"Remark"}
          closePopUp={closePopUp}
          confirmPopup={() => handleRequestForConfirmation(1)}
          isInputField={true} // Assuming you want an input field in your popup
        />
      )}
    </div>
  );
};

export default ImprovementPlan;
